import getRandomValuesPolyfill from 'polyfill-crypto.getrandomvalues';

var getRandomValues = getRandomValuesPolyfill;
if (process.env.TARGET === 'node') {
    getRandomValues = function (arr) {
        var randomBytes = require('crypto').randomBytes;
        return arr.map(function () {
            return parseInt(randomBytes(arr.BYTES_PER_ELEMENT || 4).toString('hex'), 16);
        });
    };
}
var getRandomValues$1 = (global.crypto && global.crypto.getRandomValues
    ? global.crypto.getRandomValues.bind(global.crypto)
    :
        global.msCrypto && global.msCrypto.getRandomValues
            ? global.msCrypto.getRandomValues.bind(global.msCrypto)
            :
                getRandomValues);

export default getRandomValues$1;
//# sourceMappingURL=getRandomValues.js.map
